import React, { PropTypes } from 'react';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import PolicyNumber from '../../coverNotePVComponent/policyNumber/PolicyNumber';

const PolicyNumberSection = (props) => {
  return (
    <div className="ebaoUtil__Top-Bottom-Line">
      <FormGroup controlId="">
        <Col componentClass={ControlLabel} sm={6}>
          <PolicyNumber
            policyNumber={props.coverNotePv.excessDetail.policyNumber}
            handleChangePolicyNumber={props.handleChangePolicyNumberSection}
            isPolicyNumberRequired={props.coverNotePv.coverNoteEntry.transactionType === 'renewal' || props.coverNotePv.coverNoteEntry.transactionType === 'endorsement' || props.coverNotePv.coverNoteEntry.transactionType === 'extension'}
          />
        </Col>
        <Col sm={6} />
      </FormGroup>
    </div>
  )
}

PolicyNumberSection.propTypes = {
  coverNotePv: PropTypes.object,
  handleChangePolicyNumberSection: PropTypes.func,
};

export default PolicyNumberSection;



// WEBPACK FOOTER //
// ./src/app/components/coverNotePVComponent/policyNumberSection/PolicyNumberSection.js